import { N600, N900 } from '@atlaskit/theme/colors';
import { ProductKey } from '@atlassiansox/bxpkit-core';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import styled from '@emotion/styled';
import React from 'react';
import { messages } from '../../messages';
import { ProductList } from '../component';
import { fontCharlieDisplay, fontCharlieText } from '../styled';
import { useAppSelector } from '../../../../redux';

export function SlideProductConfirmation() {
  const baseProductKeys = [
    ProductKey.JIRA_SOFTWARE,
    ProductKey.CONFLUENCE,
    ProductKey.BITBUCKET,
    ProductKey.OPSGENIE
  ];
  const {
    productsExisting: productsExistingArr,
    productsNew: productsNewPayload
  } = useAppSelector(({ loggedInFormData }) => loggedInFormData);

  const productsNew = productsNewPayload?.map((p) => p.product);
  const productsExisting = productsExistingArr?.filter((p) =>
    baseProductKeys.includes(p)
  );

  return (
    <>
      <Header>
        <SanitizedFormattedHtmlMessage
          {...messages.slideProductConfirmationHeader}
        />
      </Header>

      <Description>
        <SanitizedFormattedHtmlMessage
          {...messages.slideProductConfirmationSubHeader}
        />
      </Description>

      {productsExisting && productsExisting.length > 0 && (
        <>
          <ProductList products={productsExisting} isNew={false} />
        </>
      )}

      {productsNew && productsNew.length > 0 && (
        <>
          <ProductList products={productsNew} isNew={true} />
        </>
      )}
    </>
  );
}

const Header = styled.h1`
  font-family: ${fontCharlieDisplay};
  font-style: normal;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
  font-size: 26px;
  line-height: 30px;
  color: ${N600};
  letter-spacing: 0.3px;
  max-width: 300px;
  margin: 0 auto 16px auto;
  text-align: center;

  @media only screen and (max-width: 769px) {
    font-size: 24px;
    line-height: 20px;
    text-align: center;
  }
`;

const Description = styled.div`
  display: flex;
  font-family: ${fontCharlieDisplay};
  align-items: center;
  align-content: center;
  justify-content: center;
  text-align: center;
  font-size: 20px;
  font-weight: 300;
  line-height: 28px;
  letter-spacing: 0.2px;
  margin-bottom: 20px;
  color: ${N900};
  
  @media only screen and (max-width: 769px) {
    font-family: ${fontCharlieText}
    font-size: 18px;
    line-height: 26px;
    text-align: center;
  }
`;
